import styled from 'styled-components';
import {
  // eslint-disable-next-line no-restricted-imports
  Link as DesignSystemLink,
  LinkProps as DesignSystemLinkProps,
} from '@appcues/sonar';
import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
} from 'react-router-dom';

export type LinkProps = Partial<ReactRouterLinkProps> & DesignSystemLinkProps;

const Link = ({ children, href, ...unhandledProps }: LinkProps) => {
  if (href) {
    return (
      <DesignSystemLink href={href} {...unhandledProps}>
        {children}
      </DesignSystemLink>
    );
  }

  return (
    <DesignSystemLink forwardedAs={ReactRouterLink} {...unhandledProps}>
      {children}
    </DesignSystemLink>
  );
};

export default styled(Link)``;
